import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({ providedIn: 'root' })
export class ConfirmationService {
  async confirmDestructive(
    title: string,
    message: string,
    confirmText = 'Delete',
  ): Promise<boolean> {
    const result = await Swal.fire({
      title,
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#bd3b2f',
      cancelButtonColor: '#5f7481',
      focusCancel: true,
      reverseButtons: true,
      allowOutsideClick: false,
      allowEscapeKey: true,
    });

    return result.isConfirmed;
  }
}
